import React, { useMemo } from 'react';
import moment from 'moment';
import { humanize } from 'underscore.string';
import { useTranslation } from 'react-i18next';
import { sluggify } from '../../../utils/localization/utils';
import { AUTOMATED_PAYMENT_EVENTS } from 'constants/accounting';
import {
  Table,
  TableHeader,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
} from '@cargomatic/ui';

const Description = ({ ev }) => {
  const { t } = useTranslation();

  if (ev.data && ev.data.human && ev.user) {
    return (
      <>
        {t('ACCOUNTING_AUDIT_EVENT', {
          event:
            ev.type && ev.type === 'rpa-update'
              ? ev.event
              : t(sluggify(humanize(ev.event))),
          user: ev.user,
        })}
      </>
    );
  }

  if (
    AUTOMATED_PAYMENT_EVENTS.includes(ev.event) &&
    ev?.data?.automated_payment_status_event
  ) {
    return (
      <>
        {t(sluggify(ev.event))}
        <div data-testid="div-8a1b6c65">{`${t('AMOUNT')}: ${ev?.data?.amount}`}</div>
      </>
    );
  }

  return (
    <>
      {ev.type && ev.type === 'rpa-update'
        ? ev.event
        : t(sluggify(humanize(ev.event)))}
    </>
  );
};

const HistoryTable = ({ data: events = [], type }) => {
  const { t } = useTranslation();

  if (events.length === 0) {
    return (
      <p
        data-testid="h5-ee121e38"
        className="py-3 my-0 text-sm text-muted-foreground"
      >
        {t('NO_EVENTS_RECORDED', { type })}
      </p>
    );
  }

  const reversedEvents = useMemo(() => [...events].reverse(), [events]);

  const history = reversedEvents.map((ev, index) => (
    <TableRow data-testid={`tr-67b9bad1-${index}`} key={ev._id}>
      <TableCell data-testid={`td-e3fd6831-${index}`}>
        <Description ev={ev} />
      </TableCell>
      <TableCell data-testid={`td-ba7ed5ce-${index}`}>
        {ev.user || t('UNKNOWN_USER')}
      </TableCell>
      <TableCell data-testid={`td-a811adfb-${index}`}>
        {moment(ev.timestamp).format('LLLL')}
      </TableCell>
    </TableRow>
  ));

  return (
    <div data-testid="div-954cad61" className="overflow-x-auto">
      <Table data-testid="table-8b2e37d2">
        <TableHeader data-testid="thead-f0114464">
          <TableRow data-testid="tr-7680c5bb">
            <TableHead data-testid="th-971a159e">
              {t('EVENT', { count: 1 })}
            </TableHead>
            <TableHead data-testid="th-4b7456fd">{t('TRIGGERED_BY')}</TableHead>
            <TableHead data-testid="th-279e32a3">{t('TIME')}</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody data-testid="tbody-e9cadd88">{history}</TableBody>
      </Table>
    </div>
  );
};

export default HistoryTable;
